import { WidgetV2 } from 'src/app/interfaces/api/chart';

export const defaultProjectWidgetsConfig: WidgetV2[] = [
    {
        index: "0",
        version: 0,
        width: 400,
        height: 400,
        data: [],
        visible: true,
        title: "track_count",
        category: "track",
        type: "barStacked",
        graphType: "chart",
        chartType: "bar",
        design: {
            "format": {
                "type": "number"
            },
            "chart": {
                "title": {
                    "text": "Nb. track par project",
                    "fontSize": "15"
                },
                "legend": {
                    "display": true
                }
            },
            "chartType": "bar",
            "scales": {
                "x": {
                    "stacked": true
                },
                "y": {
                    "stacked": true
                }
            }
        },
        query: {
            "filters": {
            },
            "field": {
                "projects": {
                    "type": "string",
                    "options": []
                },
            },
            "aggregation": {
                "tracks": {
                    "type": "number",
                    "options": []
                },
            }
        }
    },
    {
        index: "0",
        version: 0,
        width: 400,
        height: 400,
        data: [],
        visible: true,
        title: "metric_count",
        category: "track",
        design: {
            "type": "barStacked",
            "format": {
                "type": "number"
            },
            "chart": {
                "title": {
                    "text": "Nb. metriques par project",
                    "fontSize": "15"
                },
                "legend": {
                    "display": true
                }
            },
            "chartType": "bar",
            "scales": {
                "x": {
                    "stacked": true
                },
                "y": {
                    "stacked": true
                }
            }
        },
        query: {
            "filter": {
            },
            "field": {
                "projects": {
                    "type": "string",
                    "options": []
                },
            },
            "aggregation": {
                "metrics": {
                    "type": "number",
                    "options": []
                },
            }
        }
    },
    {
        index: "0",
        version: 0,
        width: 300,
        height: 400,
        data: [],
        visible: true,
        title: "attachment_count",
        category: "track",
        design: {
            "type": "barStacked",
            "format": {
                "type": "number"
            },
            "chart": {
                "title": {
                    "text": "Nb. d'images par project",
                    "fontSize": "15"
                },
                "legend": {
                    "display": true
                }
            },
            "chartType": "bar",
            "scales": {
                "x": {
                    "stacked": true
                },
                "y": {
                    "stacked": true
                }
            }

        },
        query: {
            "filters": {
            },
            "field": {
            },
            "aggregation": {
                "attachments": {
                    "type": "number",
                    "options": {}
                },
            }
        }
    }
];

export const projectWidgetsConfig: WidgetV2[] = [
    {
        index: "0",
        version: 0,
        width: 600,
        height: 300,
        data: [],
        visible: true,
        title: "cumulated_time",
        category: "metric",
        databaseSeries: true,
        design: {
            "type": "columnStacked",
            "format": {
                "type": "timing",
                "timeFormat": "1h23m45s"
            },
            "chart": {
                "title": {
                    "text": "Temps cumulé des coups de grue",
                    "fontSize": "15"
                },
                "legend": {
                    "display": true
                }
            },
            "chartType": "bar",
            "scales": {
                "x": {
                    "stacked": true
                },
                "y": {
                    "stacked": true
                }
            }

        },
        query: {
            "filters": {
                "name": {
                    "type": "string",
                    "options": {
                        "value": "Coup de grue"
                    }
                }
            },
            "field": {
                "createdDate": {
                    "type": "date",
                    "options": {
                        "binning": "month",
                        "order": "ascending"
                    }

                }
            },
            "aggregation": {
                "payload.duration": {
                    "type": "number",
                    "options": {
                        "aggregate": "sum"
                    }

                }
            },
            "series": {}

        }
    },
    // {
    //     index: "0",
    // version:0,
    //     width: 600,
    //     height: 300,
    //     data: [],
    //     visible: true,
    //     config: {
    //         name: "cumulated_waiting",
    //         collection: "metric",
    //         chartOptions: {
    //             "type": "columnStacked",
    //             "format": {
    //                 "type": "timing",
    //                 "timeFormat": "1h23m45s"
    //             },
    //             "chart": {
    //                 "title": {
    //                     "text": "Temps cumulé des attentes supérieures à 3 min",
    //                     "fontSize": "15"
    //                 },
    //                 "legend": {
    //                     "display": true
    //                 }
    //             },
    //             "chartType": "bar",
    //             "scales": {
    //                 "x": {
    //                     "stacked": true
    //                 },
    //                 "y": {
    //                     "stacked": true
    //                 }
    //             }

    //         },
    //         query: {
    //             "filter": {
    //                 "payload.title": {
    //                     "type": "string",
    //                     "options": [
    //                         {
    //                             "name": "value",
    //                             "value": "Attente"
    //                         }
    //                     ]
    //                 },
    //                 "payload.duration": {
    //                     "type": "number",
    //                     "options": [
    //                         {
    //                             "name": "useMin",
    //                             "value": true
    //                         },
    //                         {
    //                             "name": "min",
    //                             "value": 120
    //                         }
    //                     ]
    //                 }
    //             },
    //             "field": {
    //                 "createdDate": {
    //                     "type": "date",
    //                     "options": [
    //                         {
    //                             "type": "select",
    //                             "name": "binning",
    //                             "value": "month"
    //                         },
    //                         {
    //                             "name": "order",
    //                             "value": "ascending"
    //                         }
    //                     ]
    //                 }
    //             },
    //             "aggregation": {
    //                 "payload.duration": {
    //                     "type": "number",
    //                     "options": [
    //                         {
    //                             "type": "select",
    //                             "name": "aggregate",
    //                             "value": "sum"
    //                         }
    //                     ]
    //                 }
    //             }

    //         }
    //     }

    // },
    {
        index: "0",
        version: 0,
        width: 600,
        height: 300,
        data: [],
        visible: true,
        title: "cumulated_waiting",
        category: "metric",
        databaseSeries: false,
        design: {
            "type": "columnStacked",
            "format": {
                "type": "timing",
                "timeFormat": "1h23m"
            },
            "chart": {
                "title": {
                    "text": "Temps cumulé par heures des attentes supérieures à 3 min",
                    "fontSize": "15"
                },
                "legend": {
                    "display": false,
                    "text": "Temps"
                }
            },
            "chartType": "bar",
            "scales": {
                "x": {
                    "stacked": true,
                    "type": "date",
                    "format": "HH:mm"
                },
                "y": {
                    "stacked": true
                }
            }

        },
        query: {
            filters: {
                "payload.title": {
                    "type": "string",
                    "options": {
                        "value": "Attente"
                    }

                },
                "payload.duration": {
                    "type": "number",
                    "options": {
                        "useMin": true,
                        "min": 120
                    }
                }
            },
            field: {
                "createdDate": {
                    "type": "date",
                    "options": {
                        "binning": "hour",
                        "periodic": true,
                        "order": "ascending"
                    }
                }
            },
            aggregation: {
                "payload.duration": {
                    "type": "number",
                    "options":
                    {
                        "aggregate": "sum"
                    }
                }
            }
        }
    }
];